<template>
  <div
    class="event-detail"
    @click="onClickEventBody">
    <ul
      class="list-unstyled">
      <li
        v-if="event"
        class="event-detail__item mb-3">
        <div
          class="d-flex align-items-center p-2" 
          style="cursor: pointer;">
          <img
            v-if="event.file"
            src="@/assets/images/file-icon.svg"
            class="event-detail__file-icon">
          <div class="event-detail__category">
            {{ event.category.name }}
          </div>
          <div
            class="event-detail__color"
            :style="`background-color: ${event.color};`" />
          <h3 class="event-detail__heading">
            {{ event.title }}
          </h3>
        </div>

        <div
          class="event-detail__body">
          <div
            class="event-detail__record record p-2">
            <div class="d-flex align-items-center">
              <h4 class="record__heading pr-2">
                詳細
              </h4>
              <div class="event-detail__created">
                <div class="event-detail__created-by">
                  作成者 {{ event.createdBy.name }}
                </div>
                <div class="event-detail__created-at">
                  最終更新日時 {{ event.updatedAt | prettyDateTime }}
                </div>
              </div>
            </div>
            <div class="record__text">
              <p>{{ event.detail }}</p>
            </div>
          </div>
          <div class="event-comment p-2">
            <user-avatar
              :user="eventComment.createdBy"
              class="pr-2"
              small />
            <div class="event-comment__item">
              <div class="event-comment__created">
                <div class="event-comment__created-by">
                  {{ eventComment.createdBy.name }}
                </div>
                <div class="event-comment__created-at">
                  {{ eventComment.createdAt | prettyDateTime }}
                </div>
              </div>
              <div class="event-comment__detail">
                {{ eventComment.detail }}
              </div>
            </div>
          </div>
        </div>
      </li>
      <li v-else>
        この予定は削除されました
      </li>
    </ul>
  </div>
</template>

<script>
import UserAvatar from '@/components/parts/UserAvatar.vue'
export default {
  components: {
    UserAvatar
  },
  props: {
    eventComment: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      default: null
    }
  },
  methods: {
    onClickEventBody() {
      this.$emit('click-notification')
    }
  }
}
</script>

<style lang="scss" scoped>
.event-detail{
  position: relative;
  &__item{
    border: solid 1px $grey10;
    border-radius: 6px;
  }
  &__file-icon {
    position: absolute;
    top: -10px;
    right: -8px;
  }

  &__category {
    width: 50px;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__color {
    width: 10px;
    height: 25px;
  }

  &__heading {
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
    padding-left: 12px;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__body{
    border-top: solid 1px $grey10;
  }

  &__created {
    font-size: 10px;
    &-by {
      font-weight: 700;
    }
    &-at {
    }
  }
}

.record{
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__text{
    color: $grey17;
    white-space:pre-wrap;
    word-wrap:break-word; 
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
}

.event-comment {
  display: flex;
  background-color: $grey15;
  &__created {
    font-size: 10px;
    &-by {
      font-weight: 700;
    }
    &-at {
    }
  }

  &__detail {
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: anywhere;
  }
}
</style>